import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import './../../css/footer.css';

import ENewsForm from './ENewsForm';

function Footer({ siteInfo: { isLoading, content_pages, social } }) {
	const images = ['visa.svg', 'mastercard.svg'];
	const showNav = () => {
		return (
			<nav>
				<ul className="footer_nav">
					{content_pages.map(function(item, i) {
						if (item.title === 'Contact Us') {
							return (
								<li key={i}>
									<a href="https://fireoneup.com/contact">{item.title}</a>
								</li>
							);
						} else if (item.title === 'FAQ') {
							return (
								<li key={i}>
									<a href="https://fireoneup.com/faqs">{item.title}</a>
								</li>
							);
						} else {
							return (
								<li key={i}>
									<Link to={`/${item.permalink}`}>{item.title}</Link>
								</li>
							);
						}
					})}
				</ul>
			</nav>
		);
	};

	return (
		<footer>
			<div className="body_container">
				<div className="footer_promo">
					<img
						src={`/images/logos/mercurycart.png`}
						alt="MercuryCart Powered By Digital Media"
					/>
				</div>

				<div className="footer_content">
					<div className="form_section">
						<ENewsForm />

						<div className="promo_section">
							<a
								href="https://www.geotrust.com/"
								target="_blank"
								rel="noopener noreferrer"
							>
								<img src={`/images/logos/geotrust.png`} alt="GeoTrust" />
							</a>
						</div>
					</div>
					<div className="nav_section">
						{isLoading ? null : (
							<React.Fragment>
								{showNav()}

								<div className="copyright">&copy; 2020 Fire One Up.</div>

								<div className="icon_nav">
									<div className="card_nav">
										{images.map((img, index) => (
											<img
												style={{ height: '48px' }}
												key={index}
												src={require(`../../images/payment-methods/${img}`)}
												alt=""
											/>
										))}
									</div>
									<div className="social_nav">
										{!!social &&
											social.map(
												(item, i) =>
													item.url && (
														<a
															className={`nav_item icon-${
																item.social_media_type
															}`}
															href={item.url}
															target="_blank"
															rel="noopener noreferrer"
															key={i}
														>
															{' '}
														</a>
													)
											)}
									</div>
								</div>
							</React.Fragment>
						)}
					</div>
				</div>
			</div>
		</footer>
	);
}

export default connect((state) => ({
	siteInfo: state.siteInfo,
}))(Footer);



// WEBPACK FOOTER //
// ./src/components/footer/Footer.js